export const pathVars = {
  initial: {
    opacity: 0,
    pathLength: 0,
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
    },
  },
  animate: {
    opacity: 1,
    pathLength: 1,
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
      delay: 0.3,
    },
  },
};

export const gridVars = {
  animate: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

export const contentVars = {
  initial: {
    opacity: 0,
    y: 20,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.6, 0.05, 0.01, 0.9],
    },
  },
};

export const isMobile =
  typeof window !== 'undefined' && window?.innerWidth < 1024;
